import { render, staticRenderFns } from "./msgList.vue?vue&type=template&id=961ce67c&scoped=true&"
import script from "./msgList.vue?vue&type=script&lang=js&"
export * from "./msgList.vue?vue&type=script&lang=js&"
import style0 from "./msgList.vue?vue&type=style&index=0&id=961ce67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961ce67c",
  null
  
)

export default component.exports